<template>
	<v-dialog scrollable persistent v-model="showDialog" max-width="820">
		<v-card>
			<v-card-title>Report Sorting</v-card-title>

			<v-card-text>
				<v-form ref="form">
					<v-row no-gutters>
						<v-text-field
							disabled
							v-if="hasCustomData"
							label="Schema"
							v-model="report.CustomData"
							:rules="[rules.required]"
						/>
						<v-select
							v-else
							label="Schema"
							v-model="schema"
							:items="schemas"
							item-value="Id"
							item-text="Name"
						/>
					</v-row>
					<v-row no-gutters>
						<v-autocomplete
							label="Field"
							:items="fields"
							item-value="Id"
							v-model="field"
							item-text="Label"
							:rules="[rules.required]"
						/>
					</v-row>
					<v-row no-gutters>
						<v-select
							label="Operator"
							v-model="operator"
							:items="operators"
							item-text="label"
							item-value="value"
							:rules="[rules.required]"
						/>
					</v-row>
				</v-form>
			</v-card-text>

			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn @click.stop="onClose">Close</v-btn>
				<v-btn color="primary" @click.stop="onSave">
					<v-icon class="mr-2">mdi-content-save</v-icon>Save
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import { ReportDetailsGetters } from '../../../../../store/getters';
import { ReportDetailsActions } from '../../../../../store/actions';
import { reportTypes } from '../../../../../enums/reportTypes';

export default {
	name: 'ReportSortingModal',
	props: {
		showDialog: Boolean,
		reportSorting: Object,
		index: Number,
	},
	computed: {
		hasCustomData() {
			if (!this.report) return null;
			if (!this.report.Type) return false;
			return this.report.Type == reportTypes.CUSTOM_DATA;
		},
		...mapGetters({
			report: [ReportDetailsGetters.REPORT],
			reportGridViewFields: [ReportDetailsGetters.REPORT_GRIDVIEW_FIELDS],
			reportFields: [ReportDetailsGetters.REPORT_FIELDS],
			schemas: [ReportDetailsGetters.REPORT_FIELDS_SCHEMAS],
		}),

		fields() {
			if (!this.reportFields) return [];
			let usedFields = this.report.Sortings.map((x) => x.ReportFieldId);
			let availableFields = this.reportFields.filter(
				(f) => !usedFields.includes(f.Id)
			);
			if (this.selectedReportField)
				availableFields.push(
					this.reportFields.find(
						(x) => x.Id == this.selectedReportField
					)
				);
			if (this.hasCustomData) return availableFields;
			if (!this.schema) return availableFields;
			let result = [];
			this.reportFields.forEach((field) => {
				let gvf = availableFields.find(
					(x) => x.GridViewFieldId == field.GridViewFieldId
				);
				if (gvf && gvf.DataField.EntityId == this.schema) {
					result.push(field);
				}
			});
			return result;
		},
	},
	watch: {
		schema(newVal, oldVal) {
			if (oldVal && newVal) {
				this.field = null;
			}
		},
	},
	data() {
		return {
			rules: {
				required: (value) => !!value || 'Field is required',
			},
			operators: [
				{ value: 1, label: 'Ascending' },
				{ value: -1, label: 'Descending' },
			],
			schema: null,
			field: null,
			operator: null,
			selectedReportField: null,
		};
	},
	mounted() {
		if (this.reportSorting) {
			if (!this.hasCustomData) this.setSchema();
			this.field = this.reportSorting.ReportFieldId;
			this.operator = this.reportSorting.Operator;
			this.selectedReportField = this.reportSorting.ReportFieldId;
		}
	},
	methods: {
		setSchema() {
			if (this.schemas && this.reportGridViewFields) {
				let field = this.reportFields.find(
					(x) => x.Id == this.reportSorting.ReportFieldId
				);
				if (field && field.GridViewFieldId) {
					let gvf = this.reportGridViewFields.find(
						(x) => x.Id == field.GridViewFieldId
					);
					if (gvf) {
						let schema = this.schemas.find(
							(x) => x.Id == gvf.EntityId
						);
						this.schema = schema.Id;
					}
				}
			}
		},

		onClose() {
			this.$emit('close');
		},
		onSave() {
			if (!this.$refs.form.validate()) return;
			if (!this.reportSorting) {
				this.add();
			} else {
				this.update();
			}
		},
		add() {
			let item = {
				ReportId: this.report.Id,
				ReportFieldId: this.field,
				Operator: this.operator,
				Order: this.index + 1,
			};
			this.$store
				.dispatch(ReportDetailsActions.ADD_REPORT_SORTING, item)
				.then((success) => {
					if (!success) return;
					this.$emit('close');
				});
		},

		update() {
			this.reportSorting.ReportFieldId = this.field;
			this.reportSorting.Operator = this.operator;
			this.$store
				.dispatch(
					ReportDetailsActions.UPDATE_REPORT_SORTING,
					this.reportSorting
				)
				.then((success) => {
					if (!success) return;
					this.$emit('close');
				});
		},
	},
};
</script>
